import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography
} from '@material-ui/core';

import Service from './Service';

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: '0px',
    padding: '50px 0px',
  },
  title: {
    margin: '30px 0px',
    fontWeight: 700,
  },
  decoration: {
    borderBottom: '1px solid #FF0000',
  }
});

const serviceDatas = [
  {
    index: 0,
    name: 'エンジニア人材開拓業',
    description: 'エンジニアの新技術習熟および新技術プロジェクトへ参画できることを促すための機会を創出する。',
    image: '/static/images/landscape.jpg',
    title: '',
  },
  {
    index: 1,
    name: 'システム開発',
    description: 'お客様のご要望を満たすだけでなく常に最善のプロセスをご提案の上、迅速にシステム開発を推進する。',
    image: '/static/images/network.jpg',
    title: '',
  }
];

class Services extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="display1" align="center" className={classes.title}>
          事業内容
        </Typography>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="center"
        >
        {serviceDatas.map(data => (
          <Grid item key={data.index} xs={10} sm={4} align="center">
            <Service
              name={data.name}
              description={data.description}
              image={data.image}
              title={data.title}
            />
          </Grid>
        ))}
        </Grid>
      </div>
    );
  }

};

Services.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Services);



// WEBPACK FOOTER //
// ./src/components/index/Services.js